/**
 * Flâneur Global & Kara Fine — Sitemap Interactive JavaScript
 * Features: Real-time collection search, live sector filter, category smooth jump tabs
 * Author: Flâneur Global Tech Atelier
 * Version: 2.1.0
 */
(function() {
  'use strict';

  function initSitemap() {
    var searchInput = document.getElementById('flSitemapSearch');
    var clearBtn = document.getElementById('flSitemapClear');
    var resultCount = document.getElementById('flSitemapCount');
    var catBlocks = document.querySelectorAll('.fl-sitemap-cat-block');
    var locCards = document.querySelectorAll('.fl-sitemap-loc-col');
    var allPills = document.querySelectorAll('.fl-sitemap-pill');

    if (!searchInput) return;

    function filterItems(query) {
      var q = query.trim().toLowerCase();
      var matchCount = 0;

      if (!q) {
        allPills.forEach(function(p) { p.style.display = ''; });
        catBlocks.forEach(function(b) { b.style.display = ''; });
        locCards.forEach(function(c) { c.style.display = ''; });
        if (resultCount) resultCount.textContent = '';
        if (clearBtn) clearBtn.style.display = 'none';
        return;
      }

      if (clearBtn) clearBtn.style.display = 'inline-flex';

      catBlocks.forEach(function(block) {
        var blockMatches = 0;
        var pills = block.querySelectorAll('.fl-sitemap-pill');
        pills.forEach(function(pill) {
          var text = pill.textContent.toLowerCase();
          if (text.indexOf(q) !== -1) {
            pill.style.display = '';
            blockMatches++;
            matchCount++;
          } else {
            pill.style.display = 'none';
          }
        });
        block.style.display = blockMatches > 0 ? '' : 'none';
      });

      locCards.forEach(function(card) {
        var text = card.textContent.toLowerCase();
        if (text.indexOf(q) !== -1) {
          card.style.display = '';
        } else {
          card.style.display = 'none';
        }
      });

      if (resultCount) {
        resultCount.textContent = matchCount > 0 ? 'Showing ' + matchCount + ' matching collections' : 'No matching collections found';
      }
    }

    searchInput.addEventListener('input', function(e) {
      filterItems(e.target.value);
    });

    if (clearBtn) {
      clearBtn.addEventListener('click', function() {
        searchInput.value = '';
        filterItems('');
        searchInput.focus();
      });
    }

    // Category Quick Jump
    var jumpButtons = document.querySelectorAll('.fl-sitemap-jump-btn');
    jumpButtons.forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        var targetId = this.getAttribute('data-target');
        var targetEl = document.getElementById(targetId);
        if (targetEl) {
          targetEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSitemap);
  } else {
    initSitemap();
  }
})();
